import getInventory from './getInventory';
import ProductModel from '@models/ProductModel';
import DrawModel from '@models/DrawModel';
import ProductDomainModel from '@models/ProductDomainModel';

export default async function (series, drawIsRequired = true) {
  if (!series || typeof series !== 'string') {
    return new Error('Series precisam ser string de bolões separadas pelo caracter ";".');
  }

  const seriesArr = (series || '').split(';');

  if (!seriesArr.length) { return []; }

  const draws = [];
  const seriesParsed = [];
  const isSpecialList = []

  seriesArr.forEach(item => {
    const splited = item.split(',');
    seriesParsed.push(splited[0]);
    draws.push(splited[1] || null);
    isSpecialList.push(splited[2] === '1')
  });

  const inventory = await getInventory();

  if (!inventory || !inventory.productsOnSale) return [];

  try {
    // Create products domains
    const productsDomains = {}
    inventory.productsOnSale.forEach((lot) => {
      lot = new ProductModel(lot)

      if (drawIsRequired && draws && draws.length && !draws.find((a) => parseInt(a) === lot.drawNumber)) {
        return
      }

      if (!productsDomains[lot.domain]) {
        productsDomains[lot.domain] = new ProductDomainModel({
          name: lot.domain,
          lottery: lot.lotteryID,
          badge: lot.badge,
          unitPrice: lot.unitPrice,
          moreChances: lot.moreChances || null,
          units: lot.units,
          items: [lot]
        })

        const drawInfo = inventory.portalDrawsOnSale
          ? inventory.portalDrawsOnSale.find((draw) => {
            return (
              parseInt(draw.lotteryID) === lot.lotteryID && parseInt(draw.drawNumber) === lot.drawNumber
            )
          })
          : null

        productsDomains[lot.domain].drawInfo = drawInfo
          ? new DrawModel(drawInfo)
          : null
      } else if (
        !productsDomains[lot.domain].items.find((b) => b.serie === lot.serie)
      ) {
        productsDomains[lot.domain].items.push(lot)
      }
    });

    // Create Series Groups
    const seriesGroups = []

    seriesParsed.forEach((serie, index) => {
      if (drawIsRequired && !draws[index]) {
        return
      }

      if (serie == '') {
        return;
      }

      const productDomain = Object.assign({}, productsDomains[serie])

      if (!productDomain) {
        return
      }

      if (isSpecialList[index] !== productDomain.drawInfo.isEspecial) {
        return
      }

      if (productDomain.items && productDomain.items.length) {
        productDomain.items = productDomain.items
          .filter((item) => {
            if (drawIsRequired && draws && draws.length) {
              return parseInt(item.drawNumber) === parseInt(draws[index])
            } else {
              return true
            }
          })
          .sort((a, b) => {
            return (
              +(a.drawDate > b.drawDate) || +(a.drawDate === b.drawDate) - 1
            )
          })
      }

      if (Object.keys(productDomain).length) {
        seriesGroups.push(productDomain)
      }
    })

    return seriesGroups;
  } catch (err) {
    console.error(err);
    return new Error(err);
  }
}
